import { Alert, AlertIcon, Box } from "@chakra-ui/react"

import useSubgraphNetworkStatus from "../hook/useSubgraphNetworkStatus"

export function OutOfSyncWarning(props: any) {
    const { isOutOfSync, blockToBeSynced, indexedBlockNumber } = useSubgraphNetworkStatus()

    if (isOutOfSync) {
        return (
            <Box {...props}>
                <Alert status="error">
                    <AlertIcon />
                    The data has only synced to block {indexedBlockNumber} (out of sync {blockToBeSynced}). Some of the
                    data may be missing. Please check back soon.
                </Alert>
            </Box>
        )
    } else {
        return null
    }
}
